export default class OrderInvoiceDataPopup {
  constructor(order) {
    if (this.vars(order)) {
      this.setupEvents();
    }
  }

  vars(order) {
    this.order = order;
    this.form = document.getElementById('dashboardMakeOrder');
    this.popup = document.getElementById('fillInvoice');

    if (!this.order || !this.form || !this.popup) return;

    this.action = this.form.getAttribute('data-check');
    this.modal = $('#fillInvoice');
    this.submit = this.popup.querySelector('.submit');
    this.modalForm = document.getElementById('userInvoiceDataForm');
    this.submitEvt = new CustomEvent('submit', { cancelable: true });

    return true;
  }

  setupEvents() {
    this.submit.addEventListener('click', () => {
      this.modalForm.dispatchEvent(this.submitEvt);
    });
  }

  validateUserData() {
    axios.post(this.action, {})
    .then((response) => {
      if (!response || response.status !== 200) {
        throw new Error(response.statusText);
      } else {
        if (response.data.message === 'OK') {
          this.order.invoiceDataCheckOk();
        } else {
          this.order.invoiceDataCheckError();
          this.showPopup();
        }
      }
    })
    .catch((error) => {
      document._kweber.toast({
        type: 'error',
        title: 'Błąd walidacji danych faktury'
      });
    });
  }

  showPopup() {
    $(this.modal).modal('show');
  }

  hidePopup() {
    $(this.modal).modal('hide');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/OrderInvoiceDataPopup.js